import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import errorTrack from '../../../util/Genesys';

const { publicRuntimeConfig } = getConfig();

const DataRetrievalModal = ({ dataRetrievalModal }) => {
  const router = useRouter();
  const handleOk = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_CONTACT_NUMBER}`);
  };
  const handleChatNow = modalId => {
    errorTrack(modalId);
  };
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'data_retrieval_issue',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={dataRetrievalModal.value}
      handleClose={dataRetrievalModal.disable}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      iconAlt={cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.alternativeText}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `}
      cta={[
        {
          // text: 'Chat now',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Chat now',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleChatNow(cmsCollectionData?.attributes?.modalID),
        },
        {
          // text: 'Call 1800 303 641',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Call 1800 303 641',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => handleOk(dataRetrievalModal),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default DataRetrievalModal;
